export const CMS_API = {
  BANNERS: '/cms/banners',
  CONTACTS: '/contacts',

  // News
  POSTS_BY_CATEGORY: '/cms/news/posts',
  POST_DETAIL: '/cms/news/post'
}
